import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InsurancePolicies from '@/components/insurance/InsurancePolicies';
import InsuranceAnalytics from '@/components/insurance/InsuranceAnalytics';

export default function Insurance() {
  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8">
        <h1 className="text-4xl font-semibold tracking-tight mb-2">Insurance</h1>
        <p className="text-muted-foreground">Track insurance policies and profitability.</p>
      </div>

      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="policies">Policies</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics">
          <InsuranceAnalytics />
        </TabsContent>

        <TabsContent value="policies">
          <InsurancePolicies />
        </TabsContent>
      </Tabs>
    </div>
  );
}
